var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: { id: "main_content_maxwidthset", cols: "12" },
        },
        [
          _c(
            "v-col",
            {
              staticClass: "ma-0 pa-5",
              attrs: { cols: "12", align: "center" },
            },
            [
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0 mt-15",
                  attrs: { cols: "12", id: "group_box" },
                },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-2",
                      attrs: { cols: "12", id: "group_box_title" },
                    },
                    [
                      _vm.searchOn == false && _vm.shareOn == false
                        ? [_vm._v(" " + _vm._s(_vm.tg("createTitle")) + " ")]
                        : _vm._e(),
                      _vm.searchOn == true && _vm.filterOn == false
                        ? [_vm._v(" " + _vm._s(_vm.t("storeSearch")) + " ")]
                        : _vm._e(),
                      _vm.searchOn == true && _vm.filterOn == true
                        ? [_vm._v(" " + _vm._s(_vm.t("storeSearch")) + " ")]
                        : _vm._e(),
                      _vm.searchOn == false && _vm.shareOn == true
                        ? [_vm._v(" " + _vm._s(_vm.t("sharUserSetting")) + " ")]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm.searchOn == false && _vm.shareOn == false
                    ? _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pt-6 pb-6 pl-15 pr-15",
                          attrs: { cols: "12", align: "left" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 pb-2",
                              attrs: { cols: "12" },
                            },
                            [_vm._v(_vm._s(_vm.tg("nameInput")))]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 pb-5",
                              attrs: { cols: "12" },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.groupName,
                                    expression: "groupName",
                                  },
                                ],
                                staticClass: "group_input",
                                staticStyle: { width: "100%", height: "2rem" },
                                attrs: {
                                  placeholder: _vm.tg("nameInputPlaceholder"),
                                },
                                domProps: { value: _vm.groupName },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.groupName = $event.target.value
                                  },
                                },
                              }),
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 pb-2",
                              attrs: { cols: "12" },
                            },
                            [_vm._v(_vm._s(_vm.tg("storeNameInput")))]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 pb-3",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { align: "center", justify: "center" },
                                },
                                [
                                  _c("v-autocomplete", {
                                    staticStyle: { width: "67%" },
                                    attrs: {
                                      items: _vm.searchResult,
                                      loading: _vm.searchLoading,
                                      "search-input": _vm.search,
                                      "append-icon": "",
                                      color: "white",
                                      dark: "",
                                      "hide-no-data": "",
                                      "hide-selected": "",
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "",
                                      "item-text": "customerName",
                                      placeholder: _vm.tg(
                                        "storeNameInputPlaceholder"
                                      ),
                                      "return-object": "",
                                    },
                                    on: {
                                      "update:searchInput": function ($event) {
                                        _vm.search = $event
                                      },
                                      "update:search-input": function ($event) {
                                        _vm.search = $event
                                      },
                                    },
                                    model: {
                                      value: _vm.storeSearchInputValue,
                                      callback: function ($$v) {
                                        _vm.storeSearchInputValue = $$v
                                      },
                                      expression: "storeSearchInputValue",
                                    },
                                  }),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "blue_btn ma-0 pa-2 ml-2",
                                      attrs: {
                                        width: "12%",
                                        height: "auto",
                                        id: "blue_btn1",
                                        elevation: "0",
                                      },
                                      on: { click: _vm.addStore },
                                    },
                                    [_vm._v(" " + _vm._s(_vm.tg("add")) + " ")]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "blue_btn ma-0 pa-2 ml-2",
                                      attrs: {
                                        width: "18%",
                                        height: "auto",
                                        id: "blue_btn2",
                                        elevation: "0",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.searchOn = true
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.tg("search")) + " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { cols: "12", id: "store_list" },
                            },
                            _vm._l(
                              _vm.selectedStoreList,
                              function (item, index) {
                                return _c(
                                  "v-col",
                                  {
                                    key: index,
                                    staticClass: "ma-0 pa-0 pl-1 pr-1",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-2 pt-1 pb-1",
                                        attrs: { cols: "12", id: "store_item" },
                                      },
                                      [
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: {
                                              align: "center",
                                              justify: "space-between",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(item.customerName) +
                                                " "
                                            ),
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "ma-0 pa-0 mr-5",
                                                attrs: {
                                                  width: "auto",
                                                  height: "auto",
                                                  id: "back_clean_btn",
                                                  elevation: "0",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.deleteStore(
                                                      index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("v-img", {
                                                  staticClass: "ma-0 pa-0",
                                                  attrs: {
                                                    "max-height": "1.25rem",
                                                    "max-width": "1.25rem",
                                                    src: require("@/assets/images/close.png"),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0 pt-3 pb-2",
                                  attrs: { cols: "12" },
                                },
                                [_vm._v(_vm._s(_vm.tg("selectLabel")))]
                              ),
                              _c("v-select", {
                                staticClass: "ma-0 pa-0",
                                attrs: {
                                  items: _vm.labelList,
                                  dense: "",
                                  "hide-details": "",
                                  outlined: "",
                                  dark: "",
                                  "item-text": "labelName",
                                  "item-value": "id",
                                },
                                model: {
                                  value: _vm.selectedLabelId,
                                  callback: function ($$v) {
                                    _vm.selectedLabelId = $$v
                                  },
                                  expression: "selectedLabelId",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 mt-5",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { align: "center", justify: "center" },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "ma-0 pa-2 mr-3",
                                      attrs: {
                                        width: "8rem",
                                        height: "auto",
                                        id: "grey_btn",
                                        elevation: "0",
                                      },
                                      on: { click: _vm.cancelGroup },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.tg("cancel")) + " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "blue_btn ma-0 pa-2",
                                      attrs: {
                                        width: "8rem",
                                        height: "auto",
                                        id: "blue_btn3",
                                        elevation: "0",
                                      },
                                      on: { click: _vm.makeGroup },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.tg("create")) + " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.searchOn == true && _vm.filterOn == false
                    ? _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { justify: "center" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-3 pt-5 pb-5",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { id: "brand_box", cols: "12" },
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: {
                                        align: "center",
                                        justify: "start",
                                      },
                                    },
                                    [
                                      _vm.brandLoading == false
                                        ? [
                                            _c(
                                              "v-item-group",
                                              {
                                                staticClass: "ma-0 pa-0",
                                                attrs: {
                                                  dense: "",
                                                  dark: "",
                                                  "hide-details": "",
                                                  column: false,
                                                  multiple: "",
                                                },
                                                model: {
                                                  value: _vm.selectedBrands,
                                                  callback: function ($$v) {
                                                    _vm.selectedBrands = $$v
                                                  },
                                                  expression: "selectedBrands",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-row",
                                                  {
                                                    staticClass: "ma-0 pa-0",
                                                    attrs: { align: "center" },
                                                  },
                                                  _vm._l(
                                                    _vm.brandList,
                                                    function (item, index) {
                                                      return _c(
                                                        "v-col",
                                                        {
                                                          key: index,
                                                          staticClass:
                                                            "ma-0 pa-0 ml-1 mr-1 mb-1",
                                                          attrs: {
                                                            cols: "auto",
                                                          },
                                                        },
                                                        [
                                                          _c("v-item", {
                                                            attrs: {
                                                              value: item,
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "default",
                                                                  fn: function (
                                                                    ref
                                                                  ) {
                                                                    var active =
                                                                      ref.active
                                                                    var toggle =
                                                                      ref.toggle
                                                                    return [
                                                                      _c(
                                                                        "v-col",
                                                                        {
                                                                          staticClass:
                                                                            "ma-0 pa-2 grey_item",
                                                                          class:
                                                                            {
                                                                              selected_item:
                                                                                active,
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              cols: "auto",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              toggle,
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-row",
                                                                            {
                                                                              staticClass:
                                                                                "ma-0 pa-0",
                                                                              attrs:
                                                                                {
                                                                                  align:
                                                                                    "center",
                                                                                },
                                                                            },
                                                                            [
                                                                              active
                                                                                ? [
                                                                                    _c(
                                                                                      "input",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            id: "check_box",
                                                                                            type: "checkbox",
                                                                                          },
                                                                                        domProps:
                                                                                          {
                                                                                            checked:
                                                                                              active,
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ]
                                                                                : [
                                                                                    _c(
                                                                                      "input",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            id: "check_box",
                                                                                            type: "checkbox",
                                                                                          },
                                                                                        domProps:
                                                                                          {
                                                                                            checked:
                                                                                              active,
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ],
                                                                              _c(
                                                                                "v-col",
                                                                                {
                                                                                  staticClass:
                                                                                    "ma-0 pa-0 ml-2",
                                                                                  attrs:
                                                                                    {
                                                                                      cols: "auto",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        item.brandName +
                                                                                          " (" +
                                                                                          item.count +
                                                                                          ")"
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                            2
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        : [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0 ml-5",
                                                attrs: { cols: "auto" },
                                              },
                                              [
                                                _c("v-progress-circular", {
                                                  attrs: {
                                                    indeterminate: "",
                                                    color: "white",
                                                    width: 4,
                                                    size: 30,
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                              _vm.selectedBrands.length != 0 && _vm.uacSupport
                                ? _c(
                                    "v-row",
                                    {
                                      staticClass: "ma-0 pa-0 pl-2",
                                      attrs: { align: "center" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.t("theConditions")) +
                                          ": "
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "ma-0 pa-2 ml-5",
                                          attrs: {
                                            width: "auto",
                                            height: "auto",
                                            id: "back_clean_btn",
                                            elevation: "0",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.filterOn = true
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              staticStyle: { color: "white" },
                                              attrs: { align: "center" },
                                            },
                                            [
                                              _c("v-img", {
                                                staticClass: "ma-0 pa-0 mr-2",
                                                attrs: {
                                                  "max-height": "1rem",
                                                  "max-width": "1rem",
                                                  src: require("@/assets/images/plus_white.png"),
                                                },
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.t("filtering")) +
                                                  " "
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.areaLoading == false
                                ? [
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "ma-0 pa-0 pb-2",
                                        attrs: { justify: "start" },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: {
                                              cols: "12",
                                              id: "noneBorderBox",
                                            },
                                          },
                                          [
                                            _vm.storeList.length > 0
                                              ? [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass:
                                                        "ma-0 pa-0 pl-1 pr-1",
                                                      attrs: { cols: "12" },
                                                    },
                                                    [
                                                      _c("v-treeview", {
                                                        attrs: {
                                                          "selected-color":
                                                            "blue",
                                                          selectable: "",
                                                          dark: "",
                                                          dense: "",
                                                          items: _vm.storeList,
                                                          "item-key": "id",
                                                          "return-object": "",
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "label",
                                                              fn: function (
                                                                ref
                                                              ) {
                                                                var item =
                                                                  ref.item
                                                                return [
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      staticClass:
                                                                        "ma-0 pa-0",
                                                                      attrs: {
                                                                        cols: "auto",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            item.id
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          false,
                                                          4157034718
                                                        ),
                                                        model: {
                                                          value:
                                                            _vm.selectedStores,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.selectedStores =
                                                              $$v
                                                          },
                                                          expression:
                                                            "selectedStores",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              : _vm.storeList.length == 0 &&
                                                _vm.selectedBrands.length !=
                                                  0 &&
                                                _vm.selectedStores.length == 0
                                              ? [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "ma-0 pa-10",
                                                      attrs: { cols: "12" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.t("noData")
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                : [
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "ma-0 pa-0 pb-2",
                                        attrs: { justify: "start" },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: {
                                              cols: "12",
                                              id: "noneBorderBox",
                                            },
                                          },
                                          [
                                            _c("v-skeleton-loader", {
                                              attrs: {
                                                boilerplate: false,
                                                elevation: "0",
                                                dark: "",
                                                type: "list-item-three-line, list-item-two-line, list-item-three-line",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                              _c(
                                "v-row",
                                {
                                  staticClass: "ma-0 pa-0 pt-2 pb-2",
                                  attrs: { align: "center", justify: "center" },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: {
                                        width: "8rem",
                                        height: "2rem",
                                        id: "grey_btn",
                                      },
                                      on: { click: _vm.searchCancel },
                                    },
                                    [_vm._v(_vm._s(_vm.t("back")))]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "blue_btn ma-0 pa-0 ml-2",
                                      attrs: {
                                        width: "8rem",
                                        height: "2rem",
                                        id: "blue_btn4",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.searchOn = false
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.t("add")))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.filterOn
                    ? _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { justify: "center" },
                        },
                        [
                          _c("Filtering", {
                            attrs: { filterOn: _vm.filterOn },
                            on: {
                              close: _vm.filterCloseFunc,
                              close2: _vm.filterClose2Func,
                              getArea: _vm.getAreaFunc,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.shareOn == true && _vm.searchOn == false
                    ? _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pt-6 pb-6 pl-15 pr-15",
                          attrs: { cols: "12", align: "left" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 pb-5",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { align: "center" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0 pr-2",
                                      attrs: { cols: "10" },
                                    },
                                    [
                                      _c("v-autocomplete", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          items: _vm.allShareUserList,
                                          loading: _vm.searchLoading,
                                          "search-input": _vm.search,
                                          "append-icon": "",
                                          color: "white",
                                          dark: "",
                                          "hide-no-data": "",
                                          "hide-selected": "",
                                          outlined: "",
                                          dense: "",
                                          "hide-details": "",
                                          "item-text": "name",
                                          placeholder: _vm.tg(
                                            "shareInputPlaceholder"
                                          ),
                                          "return-object": "",
                                        },
                                        on: {
                                          "update:searchInput": function (
                                            $event
                                          ) {
                                            _vm.search = $event
                                          },
                                          "update:search-input": function (
                                            $event
                                          ) {
                                            _vm.search = $event
                                          },
                                        },
                                        model: {
                                          value: _vm.shareUserInputValue,
                                          callback: function ($$v) {
                                            _vm.shareUserInputValue = $$v
                                          },
                                          expression: "shareUserInputValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: { cols: "2" },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "blue_btn ma-0 pa-0",
                                          attrs: {
                                            width: "100%",
                                            height: "2rem",
                                            id: "blue_btn6",
                                            elevation: "0",
                                          },
                                          on: { click: _vm.addShareUser },
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(_vm.t("add")) + " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { cols: "12", id: "store_list" },
                            },
                            _vm._l(_vm.shareUserList, function (item, index) {
                              return _c(
                                "v-col",
                                {
                                  key: index,
                                  staticClass: "ma-0 pa-0 pl-1 pr-1",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-2 pt-1 pb-1",
                                      attrs: { cols: "12", id: "user_item" },
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "ma-0 pa-0",
                                          attrs: {
                                            align: "center",
                                            justify: "space-between",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0 pl-3",
                                              attrs: { cols: "auto" },
                                            },
                                            [_vm._v(_vm._s(item.name))]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: { cols: "auto" },
                                            },
                                            [_vm._v(_vm._s(item.mailAddress))]
                                          ),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "ma-0 pa-0 mr-5",
                                              attrs: {
                                                width: "auto",
                                                height: "auto",
                                                id: "back_clean_btn",
                                                elevation: "0",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteShareUser(
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("v-img", {
                                                staticClass: "ma-0 pa-0",
                                                attrs: {
                                                  "max-height": "1.25rem",
                                                  "max-width": "1.25rem",
                                                  src: require("@/assets/images/close.png"),
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0 mt-5",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { align: "center", justify: "center" },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "ma-0 pa-2",
                                      attrs: {
                                        width: "8rem",
                                        height: "auto",
                                        id: "grey_btn",
                                        elevation: "0",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.shareOn = false
                                        },
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(_vm.t("back")) + " ")]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "blue_btn ma-0 pa-2 ml-2",
                                      attrs: {
                                        width: "8rem",
                                        height: "auto",
                                        id: "blue_btn7",
                                        elevation: "0",
                                        loading: _vm.addLoading,
                                      },
                                      on: { click: _vm.requestAddStoreGroup },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.tg("groupCreate")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }